import { useToast } from '@chakra-ui/react'
import { upperFirst } from 'lodash'
import { useState } from 'react'

import { requestApi } from '../api/request-handler'

export enum DownloadType {
  Refresh = 'Refresh',
  DownloadNew = 'Download',
}
export enum RequestType {
  CompetitorsRequest = 'CompetitorsRequest',
  TournamentsRequest = 'TournamentsRequest',
}
export type StatusType = 'success' | 'error'

export const useCompetitionSync = () => {
  const [sending, setSending] = useState(false)
  const toast = useToast()

  const sendFeedToast = (type: RequestType, status: StatusType) => {
    toast({
      title: `${upperFirst(type)} feed ${status === 'success' ? 'sent successfully' : 'send failed'}`,
      status: status,
      duration: 3000,
    })
  }

  const sendRefreshDLRequest = async (type: RequestType, compId: string, clearCache: boolean = false) => {
    setSending(true)
    let path = `sds/comp/refresh/${compId}`
    if (type === RequestType.TournamentsRequest) {
      path = `sds/comp/download/${compId}`
    }

    try {
      const response = await requestApi(path, {
        method: 'PUT',
        params: {
          clearCache: clearCache ? 'true' : undefined,
        },
      })
      if (response) {
        setSending(false)
        sendFeedToast(type, response.ok ? 'success' : 'error')
      }
    } catch (error) {
      console.warn('Error sending Feed', error) // eslint-disable-line no-console
      setSending(false)
      sendFeedToast(type, 'error')
    }
  }

  // Function to call the rename-names API
  const sendRenameNamesRequest = async (compId: string) => {
    try {
      const response = await requestApi(`admin/competitions/${compId}/rename-names`, {
        method: 'POST',
      })
      if (response.ok) {
        const data = await response.json()
        toast({
          title: 'Competition and matches renamed',
          description: data.message || 'Operation successful.',
          status: 'success',
          duration: 3000,
        })
      } else {
        toast({
          title: 'Rename failed',
          description: 'Could not rename competition and matches.',
          status: 'error',
          duration: 3000,
        })
      }
    } catch (error) {
      toast({
        title: 'Rename failed',
        description: 'An error occurred.',
        status: 'error',
        duration: 3000,
      })
    }
  }

  // Function to call the revert-names API
  const sendRevertNamesRequest = async (compId: string) => {
    try {
      const response = await requestApi(`admin/competitions/${compId}/revert-names`, {
        method: 'POST',
      })
      if (response.ok) {
        const data = await response.json()
        toast({
          title: 'Competition and matches reverted',
          description: data.message || 'Names reverted to backup.',
          status: 'success',
          duration: 3000,
        })
      } else {
        toast({
          title: 'Revert failed',
          description: 'Could not revert competition and matches.',
          status: 'error',
          duration: 3000,
        })
      }
    } catch (error) {
      toast({
        title: 'Revert failed',
        description: 'An error occurred.',
        status: 'error',
        duration: 3000,
      })
    }
  }

  return {
    sending,
    sendRefreshDLRequest,
    sendRenameNamesRequest,
    sendRevertNamesRequest,
  }
}
